import { DefaultTheme } from 'styled-components';

export const baseTheme: DefaultTheme = {
  mode: 'light',
  colors: {
    // Colors
    primary: '#042941',
    secondary: '#EB6E80',

    // Greys
    // N0: '#FFF',
    // N10: '#f8f9fa',
    // N20: '#e9ecef',
    // N30: '#DEE2E6',
    // N40: '#CED4DA',
    // N50: '#ADB5BD',
    // N60: '#6C757D',
    // N70: '#495057',
    // N80: '#343A40',
    // N90: '#212529',
    // N100: '#000',
    N0: '#FFF',
    N10: '#f8f9fa',
    N20: '#e9ecef',
    N30: '#DEE2E6',
    N40: '#CED4DA',
    N50: '#ADB5BD',
    N60: '#6C757D',
    N70: '#495057',
    N80: '#343A40',
    N90: '#212529',
    N100: '#000',

    // Meaningful colors:
    success: '#1ABC9C',
    warning: '#E67E22',
    danger: '#C0392B',
    info: '#2980B9',

    // Different brands (https://colorlib.com/brand/category/tech/)
    facebook: '#1877F2',
    google: '#4285F4',
  },

  spacing: {
    xxs: '0.125em',
    xs: '0.25em',
    sm: '0.5em',
    md: '1em',
    lg: '1.5em',
    xl: '2em',
    xxl: '4em',
  },

  breakpoint: {
    xs: '400px',
    sm: '550px',
    md: '750px',
    lg: '1000px',
    xl: '1200px',
  },
};

export const darkTheme: DefaultTheme = {
  ...baseTheme,
  mode: 'dark',
  colors: {
    ...baseTheme.colors,
    N100: '#FFF',
    N90: '#f8f9fa',
    N80: '#e9ecef',
    N70: '#DEE2E6',
    N60: '#CED4DA',
    N50: '#ADB5BD',
    N40: '#6C757D',
    N30: '#495057',
    N20: '#343A40',
    N10: '#212529',
    N0: '#000',
  },
};

export default baseTheme;
